import { ROTA_APIS } from "@/api_framework/api_config";
import { IRotaManagementShiftDetailsResponse, IRotaManagementShiftListData } from "@/api_framework/api_modals/Rota";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});
export type RotaCreationReturnType = {
  status: boolean;
  message: string;
  shiftId?: string | null;
};

export const useRotaShiftCreateAPI = () => {
  const [APIError, setAPIError] = useState<AxiosError | null>(null);
  const [shiftId, setShiftId] = useState<string>(null);
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const dispatch = useAppDispatch();
  const execute = useCallback(async (filterParams: IRotaManagementShiftListData) => {
    dispatch(
      setLoading({
        key: "isPWLInProgress",
        status: true,
      }),
    );
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const response: RotaCreationReturnType = await axios
        .post(
          ROTA_APIS?.ROTA_SHIFT_CREATE?.baseURL ?? "",
          filterParams,

          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        )
        .then((res: AxiosResponse<IRotaManagementShiftDetailsResponse>) => {
          if (res.data.status === true) {
            toast.success("Standard Shift has been created ");
            setShiftId(res.data.data.id);
            return { status: true, message: "ROTA_CREATED", shiftId: res.data.data.id };
          } else {
            setShiftId(null);
            //
            return { status: false, message: "ROTA_NOT_CREATED", shiftId: null };
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          setAPIError(e);
          setShiftId(null);
          captureError(e);
          return { status: false, message: "ROTA_NOT_CREATED", shiftId: null };
        });
      return response;
    } catch (e: any) {
      const vv = e.response.data as any;
      toast.error("Server Error: " + e.message);
      return { status: false, message: vv.message, shiftId: null };
    }
    return null;
  }, []);
  return { shiftId, APIError, execute, setShiftId };
};
